'use strict'

export default class Contact
{
  constructor()
  {
    this.$elem = $('.Contact')

    if( this.$elem.length > 0 ){
      let self = this

      this.$containerOptions = this.$elem.find('.Contact__container_options')
      this.$formContainer = this.$elem.find('.Contact__form__container')
      this.heightForm = 0

      $(document).ready(function(){
        self._options()
        //self._forms()
        self._formSoyEstudiante()
      })
    }
  }

  _formSoyEstudiante() {
    $('#vs_forms_main_soy_estudiante_universidad #soy_estudiante_universidad_field_8').on('change', function (e) {
      if( $(this).val() === 'quiero-hacer-mi-practica-laboral' ) {
        window.location.replace(`${wpURL.home_url}/talento`);
      }
    });
  }
  _options(){
    let $containerOptions = $('.Contact__container_options')
    let $options = $containerOptions.children()

    $.each($options, function( i,val ){
      let title = $(this).find('figcaption')

      title.css({
          'top': ( $(this).height() - title.height() ) / 2,
      })
      
      var resizeAgain = function( title ){
          setTimeout(function(){
              title.css({
                  'top': ( title.parents('.option').height() - title.height() ) / 2,
              })
          }, 500)
      }
      resizeAgain(title)
    })
  }
}

